import classnames from "classnames";
import {Container, Nav, NavItem, NavLink, Row} from "reactstrap";
import PropTypes from "prop-types";
import React from "react";

const NewChatTabHeaderComponent = (props) => {

    const allClassNames = classnames({
        active: props.activeTab === "all",
        "cursor-pointer": true
    });

    const usersClassNames = classnames({
        active: props.activeTab === "user",
        "cursor-pointer": true
    });

    const broadcastersClassNames = classnames({
        active: props.activeTab === "broadcasters",
        "cursor-pointer": true
    });


    return (
        <Nav tabs className="availability-requests" style={{marginLeft:-20}}>
            <NavItem className="ml-md-4">
                <NavLink
                    className={allClassNames}
                    onClick={() => props.toggle("all")}>
                    ALL
                </NavLink>
            </NavItem>
            <NavItem className="ml-md-4">
                <NavLink
                    className={usersClassNames}
                    onClick={() => props.toggle("user")}>
                    USERS
                </NavLink>
            </NavItem>
            <NavItem className="ml-md-4">
                <NavLink
                    className={broadcastersClassNames}
                    onClick={() => props.toggle("broadcasters")}>
                    BROADCASTERS
                </NavLink>
            </NavItem>
        </Nav>
    )
};

NewChatTabHeaderComponent.propTypes = {
    activeTab: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
};


export default NewChatTabHeaderComponent;